/* ML PSO9 — utilidades compartidas: carruseles con flechas, vídeos con póster (uno a la vez), contadores animados y anclas a la compra.
   Se carga UNA vez desde ml-pso9-top. Idempotente. ES5 a propósito. */
(function(){
  function stepOf(tr){ var c=tr.children[0]; if(!c) return tr.clientWidth; var g=parseFloat(getComputedStyle(tr).columnGap||getComputedStyle(tr).gap)||14; return c.getBoundingClientRect().width+g; }
  function syncArrows(root){
    var tr=root.querySelector('.p9-track'), ar=root.querySelector('.p9-arrows'); if(!tr||!ar) return;
    ar.style.display=(tr.scrollWidth>tr.clientWidth+4)?'':'none';
  }
  function bindCar(root){
    if(root.getAttribute('data-p9-bound')) return; root.setAttribute('data-p9-bound','1');
    var tr=root.querySelector('.p9-track'); if(!tr) return;
    var pv=root.querySelectorAll('[data-p9-prev]'), nx=root.querySelectorAll('[data-p9-next]'), i;
    for(i=0;i<pv.length;i++){ pv[i].addEventListener('click',function(){
      if(tr.scrollLeft<=4){ tr.scrollTo({left:tr.scrollWidth,behavior:'smooth'}); } else { tr.scrollBy({left:-stepOf(tr),behavior:'smooth'}); }
    }); }
    for(i=0;i<nx.length;i++){ nx[i].addEventListener('click',function(){
      var max=tr.scrollWidth-tr.clientWidth-4;
      if(tr.scrollLeft>=max){ tr.scrollTo({left:0,behavior:'smooth'}); } else { tr.scrollBy({left:stepOf(tr),behavior:'smooth'}); }
    }); }
    syncArrows(root);
    window.addEventListener('resize',function(){ syncArrows(root); });
    var imgs=tr.querySelectorAll('img'); for(i=0;i<imgs.length;i++){ imgs[i].addEventListener('load',function(){ syncArrows(root); }); }
  }
  function pauseOthers(v){
    var all=document.querySelectorAll('video'); for(var k=0;k<all.length;k++){ if(all[k]!==v && !all[k].paused){ try{ all[k].pause(); }catch(e){} } }
  }
  function bindVid(el){
    if(el.getAttribute('data-p9-bound')) return; el.setAttribute('data-p9-bound','1');
    el.addEventListener('click',function(){
      if(el.getAttribute('data-p9-playing')) return; el.setAttribute('data-p9-playing','1');
      var v=document.createElement('video');
      v.src=el.getAttribute('data-src'); v.controls=true; v.playsInline=true; v.setAttribute('playsinline','');
      v.setAttribute('preload','auto'); v.className='p9-vidv';
      var pi=el.querySelector('img'); if(pi){ v.poster=pi.getAttribute('src'); }
      el.innerHTML=''; el.appendChild(v);
      pauseOthers(v);
      var p=v.play(); if(p&&p.catch){ p.catch(function(){}); }
    });
  }
  /* un solo vídeo sonando: al empezar cualquiera, se pausan los demás */
  if(!window.__p9play){ window.__p9play=1; document.addEventListener('play',function(e){ if(e.target&&e.target.tagName==='VIDEO'){ pauseOthers(e.target); } },true); }
  function fmt(n){ try{ return n.toLocaleString('es-MX'); }catch(e){ return String(n); } }
  function bindCount(el){
    if(el.getAttribute('data-p9-bound')) return; el.setAttribute('data-p9-bound','1');
    var target=parseInt(el.getAttribute('data-p9-count'),10)||0, done=false;
    function run(){ if(done) return; done=true; var t0=Date.now();
      (function f(){ var p=Math.min(1,(Date.now()-t0)/1400); el.textContent=fmt(Math.round(target*(1-Math.pow(1-p,3)))); if(p<1){ requestAnimationFrame(f); } })(); }
    function vis(){ var r=el.getBoundingClientRect(); return r.top<(window.innerHeight||800)-40 && r.bottom>0; }
    if('IntersectionObserver' in window){ var io=new IntersectionObserver(function(es){ for(var k=0;k<es.length;k++){ if(es[k].isIntersecting){ run(); io.disconnect(); } } },{threshold:.2}); io.observe(el); }
    /* Horizon desplaza dentro de .page-wrapper en escritorio: escuchar en captura */
    document.addEventListener('scroll',function(){ if(!done&&vis()) run(); },{passive:true,capture:true});
    if(vis()) run();
  }
  function bindJump(a){
    if(a.getAttribute('data-p9-bound')) return; a.setAttribute('data-p9-bound','1');
    a.addEventListener('click',function(e){
      var t=document.getElementById('p9-comprar'); if(!t) return;
      e.preventDefault(); t.scrollIntoView({behavior:'smooth',block:'start'});
    });
  }
  function init(){
    var i, a=document.querySelectorAll('[data-p9-car]'); for(i=0;i<a.length;i++) bindCar(a[i]);
    a=document.querySelectorAll('[data-p9-vid]'); for(i=0;i<a.length;i++) bindVid(a[i]);
    a=document.querySelectorAll('[data-p9-count]'); for(i=0;i<a.length;i++) bindCount(a[i]);
    a=document.querySelectorAll('[data-p9-jump]'); for(i=0;i<a.length;i++) bindJump(a[i]);
  }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',init); } else { init(); }
  window.addEventListener('load',function(){ var a=document.querySelectorAll('[data-p9-car]'); for(var i=0;i<a.length;i++) syncArrows(a[i]); });
  document.addEventListener('shopify:section:load',init);
})();
